const navigateAssign = (url: string) => window.location.assign(url);
const navigateReplace = (url: string) => window.location.replace(url);
const navigateOpen = (url: string) => window.open(url, '_blank');

export const Navigate = {
  assign: navigateAssign,
  replace: navigateReplace,
  open: navigateOpen,
};
